export type EchoChannel = {
  listen(event: string, cb: (payload: unknown) => void): unknown;
  stopListening(event: string, cb?: (payload: unknown) => void): unknown;
};
export type EchoLike = { private(name: string): EchoChannel };

/** The app's single Echo connection (created in src/index.tsx). Required lazily: importing the
 *  entry file at module load would render the app inside tests. */
export const getEcho = (): EchoLike | null => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return (require("../../index").ECHO as EchoLike) ?? null;
  } catch {
    return null;
  }
};
